import React from 'react';
import { Tooltip } from '@material-ui/core';

interface IProps {
    title: string;
    children: React.ReactElement;
    disableHoverListener?: boolean;
    disableFocusListener?: boolean;
    placement?:
        | 'bottom-end'
        | 'bottom-start'
        | 'bottom'
        | 'left-end'
        | 'left-start'
        | 'left'
        | 'right-end'
        | 'right-start'
        | 'right'
        | 'top-end'
        | 'top-start'
        | 'top';
}

export const PasslyTooltip = ({ title, placement, children, disableHoverListener, disableFocusListener }: IProps) => {
    return (
        <Tooltip title={title} placement={placement} disableHoverListener={disableHoverListener} disableFocusListener={disableFocusListener} arrow>
            {children}
        </Tooltip>
    );
};
